import React, { useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const About: React.FC = () => {
  const [openAccordion, setOpenAccordion] = useState<number>(0);
  return <div className="min-h-screen pt-32 pb-20" data-id="element-90">
      {/* Hero Section */}
      <section className="container mx-auto px-4 py-20" data-id="element-91">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-92">
          <div data-id="element-93">
            <h1 className="text-4xl md:text-6xl font-bold mb-4" data-id="element-94">ABOUT ME</h1>
            <p className="text-sm font-thin tracking-widest mb-8" data-id="element-95">
              HASSAAN BASIT
            </p>
            <p className="font-thin mb-8 text-lg" data-id="element-96">
              Hi, I'm Hassaan Basit. I believe that great results come from a
              great process. As a Digital Growth Architect, I methodically build
              complete digital ecosystems for service-based businesses,
              transforming a fragmented presence into a single engine for
              predictable growth and revenue.
            </p>
            <div className="flex space-x-4" data-id="element-97">
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-98">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-99">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-100" />
                </svg>
              </a>
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-101">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-102">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-103" />
                </svg>
              </a>
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-104">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-105">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-106" />
                </svg>
              </a>
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-107">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-108">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" data-id="element-109" />
                </svg>
              </a>
              <a href="#" className="text-[#121212] dark:text-white hover:text-[#39FF14] dark:hover:text-[#39FF14] transition-colors" data-id="element-110">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-111">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-112" />
                </svg>
              </a>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden h-[500px]" data-id="element-113">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wWvs2P1Egc1Wgg3MxU85S8/Portfolio_Main_Image_.jpg" alt="Hassaan Basit" className="w-full h-full object-cover" data-id="element-114" />
          </div>
        </div>
      </section>
      {/* My Architectural Process */}
      <section className="container mx-auto px-4 py-20" data-id="element-115">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-116">
          <div className="space-y-6" data-id="element-117">
            <Accordion title="01. THE BLUEPRINT & FOUNDATION (STRATEGY)" content="Before we build anything, we plan. I conduct a deep analysis of your ideal customers, what they need, and where they spend their time online. We also study your top competitors to understand what's working in your market and, more importantly, where the hidden opportunities are for you to stand out." isOpen={openAccordion === 0} onClick={() => setOpenAccordion(0)} data-id="element-118" />
            <Accordion title="02. THE DIGITAL ECOSYSTEM (EXECUTION)" content="With the blueprint in place, we construct your core digital assets. This includes building your brand identity, developing a professional website, and designing the sales funnels that will turn visitors into customers." isOpen={openAccordion === 1} onClick={() => setOpenAccordion(1)} data-id="element-119" />
            <Accordion title="03. THE REVENUE ENGINE (GROWTH)" content="With your ecosystem built, we flip the switch. We launch targeted ad campaigns, deploy content strategies, and implement systems to manage growth, all focused on generating direct, measurable revenue." isOpen={openAccordion === 2} onClick={() => setOpenAccordion(2)} data-id="element-120" />
          </div>
          <div className="sticky top-32 h-[400px] rounded-2xl overflow-hidden" data-id="element-121">
            <img src="https://images.unsplash.com/photo-1497215842964-222b430dc094?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Modern Workspace" className="w-full h-full object-cover" data-id="element-122" />
          </div>
        </div>
      </section>
      {/* The Architect's Advantage */}
      <section className="container mx-auto px-4 py-20" data-id="element-123">
        <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center" data-id="element-124">
          THE ARCHITECT'S ADVANTAGE
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-125">
          <div className="bg-[#121212] p-8 rounded-xl" data-id="element-126">
            <h3 className="text-xl font-bold mb-6 text-white" data-id="element-127">
              The Fragmented Approach
            </h3>
            <ul className="space-y-4" data-id="element-128">
              <li className="flex items-start" data-id="element-129">
                <span className="text-red-500 mr-2" data-id="element-130">✕</span>
                <p className="font-thin text-white" data-id="element-131">
                  Juggling Multiple Freelancers: Most freelancers sell you a
                  single, disconnected piece of the puzzle.
                </p>
              </li>
              <li className="flex items-start" data-id="element-132">
                <span className="text-red-500 mr-2" data-id="element-133">✕</span>
                <p className="font-thin text-white" data-id="element-134">
                  High Agency Fees & Outsourcing: Traditional agencies charge a
                  premium for a slow, outsourced process that delivers
                  inconsistent results.
                </p>
              </li>
              <li className="flex items-start" data-id="element-135">
                <span className="text-red-500 mr-2" data-id="element-136">✕</span>
                <p className="font-thin text-white" data-id="element-137">
                  A Disconnected, Ineffective System: Without a unified
                  strategy, your marketing efforts are scattered, wasteful, and
                  fail to generate real revenue.
                </p>
              </li>
            </ul>
          </div>
          <div className="bg-[#39FF14] p-8 rounded-xl" data-id="element-138">
            <h3 className="text-xl font-bold mb-6 text-black" data-id="element-139">
              The Ecosystem Approach
            </h3>
            <ul className="space-y-4" data-id="element-140">
              <li className="flex items-start" data-id="element-141">
                <span className="text-black mr-2" data-id="element-142">✓</span>
                <p className="font-thin text-black" data-id="element-143">
                  One Complete, Integrated Engine: I don't just sell the parts;
                  I architect the entire engine. A single, unified system where
                  every component works in perfect harmony.
                </p>
              </li>
              <li className="flex items-start" data-id="element-144">
                <span className="text-black mr-2" data-id="element-145">✓</span>
                <p className="font-thin text-black" data-id="element-146">
                  A Single, Dedicated Growth Partner: You get one point of
                  contact and one person who takes full responsibility for the
                  project's success, saving you time and eliminating headaches.
                </p>
              </li>
              <li className="flex items-start" data-id="element-147">
                <span className="text-black mr-2" data-id="element-148">✓</span>
                <p className="font-thin text-black" data-id="element-149">
                  A Clear Path to Predictable Revenue: My sole mission is to
                  build the ecosystem that doubles your revenue, freeing you to
                  focus on what you do best.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/* 5-Step Ecosystem Blueprint */}
      <section className="container mx-auto px-4 py-20" data-id="element-150">
        <h2 className="text-3xl md:text-5xl font-bold mb-12" data-id="element-151">
          MY 5-STEP ECOSYSTEM BLUEPRINT
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-152">
          <div className="bg-white dark:bg-[#121212] p-8 rounded-xl shadow-lg" data-id="element-153">
            <h3 className="text-lg font-bold mb-4" data-id="element-154">
              01. DISCOVERY & BLUEPRINT
            </h3>
            <p className="font-thin" data-id="element-155">
              We start with deep research to build a data-driven strategy.
            </p>
          </div>
          <div className="bg-[#39FF14] p-8 rounded-xl shadow-lg text-black row-span-1 md:row-span-2" data-id="element-156">
            <h3 className="text-lg font-bold mb-4" data-id="element-157">
              02. ARCHITECTURE & IDENTITY
            </h3>
            <p className="font-thin" data-id="element-158">
              We build your brand's foundation and visual identity.
            </p>
          </div>
          <div className="rounded-xl overflow-hidden h-[250px]" data-id="element-159">
            <img src="https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Digital Growth" className="w-full h-full object-cover" data-id="element-160" />
          </div>
          <div className="rounded-xl overflow-hidden h-[250px]" data-id="element-161">
            <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1115&q=80" alt="Growth Strategy" className="w-full h-full object-cover" data-id="element-162" />
          </div>
          <div className="bg-white dark:bg-[#121212] p-8 rounded-xl shadow-lg" data-id="element-163">
            <h3 className="text-lg font-bold mb-4" data-id="element-164">
              03. CONSTRUCTION & CONTENT
            </h3>
            <p className="font-thin" data-id="element-165">
              We build your website and social platforms.
            </p>
          </div>
          <div className="bg-[#39FF14] p-8 rounded-xl shadow-lg text-black" data-id="element-166">
            <h3 className="text-lg font-bold mb-4" data-id="element-167">04. REVENUE ACTIVATION</h3>
            <p className="font-thin" data-id="element-168">
              We launch targeted organic and paid campaigns to drive predictable
              sales.
            </p>
          </div>
          <div className="bg-white dark:bg-[#121212] p-8 rounded-xl shadow-lg md:col-span-2" data-id="element-169">
            <h3 className="text-lg font-bold mb-4" data-id="element-170">
              05. SYSTEMIZATION & SCALING
            </h3>
            <p className="font-thin" data-id="element-171">
              We implement the systems to manage growth and ensure your success
              is sustainable.
            </p>
          </div>
          <div className="rounded-xl overflow-hidden h-[250px]" data-id="element-172">
            <img src="https://images.unsplash.com/photo-1533750349088-cd871a92f312?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Digital Systems" className="w-full h-full object-cover" data-id="element-173" />
          </div>
        </div>
      </section>
    </div>;
};
interface AccordionProps {
  title: string;
  content: string;
  isOpen: boolean;
  onClick: () => void;
}
const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  isOpen,
  onClick
}) => {
  return <div className="border-b border-gray-200 dark:border-gray-700" data-id="element-174">
      <button className="flex justify-between items-center w-full py-4 text-left" onClick={onClick} data-id="element-175">
        <h3 className="text-lg font-bold" data-id="element-176">{title}</h3>
        <ChevronDownIcon className={`w-5 h-5 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-177" />
      </button>
      <motion.div initial={false} animate={{
      height: isOpen ? 'auto' : 0,
      opacity: isOpen ? 1 : 0
    }} className="overflow-hidden" data-id="element-178">
        <div className="pb-4 font-thin" data-id="element-179">{content}</div>
      </motion.div>
    </div>;
};
export default About;